import * as queryString from 'query-string';
import React from 'react';
import { useHistory } from 'react-router';

import {
  EntityListQueryOperationQuery as EntityListQueryOperation,
  EntityListQueryOperationQueryVariables as EntityListQueryOperationVariables,
  EntitySortableField,
  SortDir,
} from 'core/graphql';
import { ValueBasedFilterTypes } from 'shared/components/internal/Filter';
import { addQuickFilterToQuery } from 'shared/components/internal/Filter/utils';
import { useFilterWithSort, useQuery } from 'shared/hooks';

import { Entities } from './Entities';
import { ENTITY_LIST_QUERY_OPERATION } from './queries';
import { sortOptions } from './sort';
import { ENTITY_QUERY_LIMIT } from './utils';

export const EntitiesList = () => {
  const history = useHistory();

  const {
    offset,
    onOffsetChange,
    onQueryChange,
    onSortChange,
    q,
    sort,
    sortDir,
  } = useFilterWithSort<EntitySortableField>({
    sortOptions,
    defaultSort: 'activityScore',
    defaultSortDir: SortDir.Desc,
  });

  const { data, loading } = useQuery<
    EntityListQueryOperation,
    EntityListQueryOperationVariables
  >(ENTITY_LIST_QUERY_OPERATION, {
    variables: {
      q,
      limit: ENTITY_QUERY_LIMIT,
      offset,
      sort,
      sortDir,
    },
  });

  const onQuickFilter = (filter: ValueBasedFilterTypes) => {
    const { q } = queryString.parse(history.location.search);
    const newQuery = addQuickFilterToQuery(filter, q as string);
    onQueryChange(newQuery);
  };

  const entities = data?.entities.objects || [];
  const total = data?.entities.total || 0;
  const threshold = data?.insightConfig?.threshold;

  return (
    <Entities
      entities={entities}
      loading={loading}
      offset={offset}
      onOffsetChange={onOffsetChange}
      onQueryChange={onQueryChange}
      onSortChange={onSortChange}
      query={q}
      sort={sort}
      sortDir={sortDir}
      threshold={threshold}
      total={total}
      onQuickFilter={onQuickFilter}
    />
  );
};
